import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  LinearProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";
import { useUserDetails } from "../../../../context/auth";

const AddShift = () => {
  const navigate = useNavigate();

  const [id, setId] = useState(null);
  const { AccessData } = useUserDetails();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [shifData, setShiftData] = useState({
    name: "",
    startTime: "",
    endTime: "",
    nameStatus: "unchecked",
    startTimeStatus: "unchecked",
    endTimeStatus: "unchecked",
  });
 
  const [totalWorkingHours,settotalWorkingHours] = useState(null)

  const [originalshiftData, setoriginalshiftData] = useState({
    name: "",
    startTime: "",
    endTime: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  //Create
  const onshiftSubmit = async () => {
    const query = `
      mutation CreateShift($shiftData: ShiftInput!) {  

  createShift(shiftData: $shiftData) {  

    shift {  

      id  

      name  

      startTime  

      endTime  

      totalWorkingHours   

    }  

    success  

    message  

    error  

  }  

} 
        `;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            shiftData: {
              name: shifData.name,
              startTime: shifData.startTime,
              endTime: shifData.endTime,
              totalWorkingHours : totalWorkingHours
            },
          },
        }),
      });

      const result = response.data.data?.createShift;
      console.log('result:',response.data);
      
      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/shift");
      }
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
    
    } catch (error) {
      console.error("responseError:", error.response?.data || error);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message: error?.message || "Something went wrong!",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  //Edit
  const oneditshiftSubmit = async () => {
    // setPageState({
    //   ...pageState,
    //   state: "submitting",
    // });

    const query = `
           mutation EditShift($id: ID!, $shiftData: ShiftInput!) { 
  editShift(id: $id, shiftData: $shiftData) { 
    shift { 
      id 
      name 
      startTime 
      endTime 
      totalWorkingHours 
    } 
    success 
    message 
    error 

  } 

} 
`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id, 
            shiftData: {
              name: shifData.name,
              startTime: shifData.startTime,
              endTime: shifData.endTime,
              totalWorkingHours : totalWorkingHours
            },
          },
        }),
      });

      let result = response.data.data.editShift;

      console.log('responseedit:',response.data);
      

      if (result.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/shift");
      }

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
     
    } catch (error) {
      console.error("responseError:", error);

      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for the inconvenience, there is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  //Delete
  const ondeleteSubmitShift = async () => {
    const query = `
        mutation DeleteShift($id: ID!) { 
  deleteShift(id: $id) { 
  success 
  message 
  error 
} 
  } `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id, // Ensure `id` is defined in the component's scope
        },
      });

      const result = response.data.data.deleteShift;

      if (result.success) {
        navigate("/shift");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Shift Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        console.error("Error deleting Shift:", result.message || "Unknown error");
      }
    } catch (error) {
      console.error("An error occurred while deleting the Shift:", error);
    }
  };

  // BY ID
  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `
  query GetShiftById($id: ID!) { 
  shiftById(id: $id) { 
    data { 
      id 
      name 
      startTime 
      endTime 
      totalWorkingHours 
    } 
    success 
    message 
    error 
  } 
} `;

    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // Extract Leavetype data from the response
      const shiftRowData = response.data.data.shiftById.data;

      console.log('shiftRowData:',shiftRowData);
      

      setShiftData({
        name: shiftRowData[0]?.name,
        startTime: shiftRowData[0]?.startTime,
        endTime: shiftRowData[0]?.endTime,
        nameStatus: shiftRowData[0]?.name ? "success" : "unchecked",
        startTimeStatus: shiftRowData[0]?.startTime ? "success" : "unchecked",
        endTimeStatus: shiftRowData[0]?.endTime ? "success" : "unchecked",
      });

      settotalWorkingHours(shiftRowData[0]?.totalWorkingHours)

      setoriginalshiftData({
        name: shiftRowData[0]?.name,
        startTime: shiftRowData[0]?.startTime,
        endTime: shiftRowData[0]?.endTime,
        nameStatus: shiftRowData[0]?.name ? "success" : "unchecked",
        startTimeStatus: shiftRowData[0]?.startTime ? "success" : "unchecked",
        endTimeStatus: shiftRowData[0]?.endTime ? "success" : "unchecked",
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        message:
          "We are unable to fetch the required data at this time. Please try again later. If the problem persists, please contact support.",
        state: "error",
      });
    }
  };

  const handleShiftchange = (event) => {
    let shiftState = { ...shifData };
    const { name, value } = event.target;
  
    switch (name) {
      case "startTime": {
        if (value?.trim()) {
          shiftState.startTime = value;
          shiftState.startTimeStatus = "success";
    
          // Reset end time when start time changes
          shiftState.endTime = "";
          shiftState.endTimeStatus = "unchecked";
          shiftState.endTimeErrorMsg = "";
        } else {
          shiftState.startTimeStatus = "error";
          shiftState.startTimeErrorMsg = "Shift Start Time is Mandatory.";
        }
        break;
      }
    
      // case "endTime": {
      //   const { startTime } = shiftState;
    
      //   if (!startTime) {
      //     shiftState.endTimeStatus = "error";
      //     shiftState.endTimeErrorMsg = "Please select a Start Time first.";
      //     break;
      //   }
    
      //   if (!value?.trim()) {
      //     shiftState.endTimeStatus = "error";
      //     shiftState.endTimeErrorMsg = "Shift End Time is Mandatory.";
      //     break;
      //   }
    
      //   const startTimeObj = new Date(`2000-01-01T${startTime}`);
      //   let endTimeObj = new Date(`2000-01-01T${value}`);
    
      //   // If end time is technically earlier (e.g., past midnight), move to next day
      //   if (endTimeObj <= startTimeObj) {
      //     endTimeObj.setDate(endTimeObj.getDate() + 1);
      //   }
    
      //   const diffHours = (endTimeObj - startTimeObj) / (1000 * 60 * 60);
      //   console.log(diffHours,"diffhoo");
        
      //   settotalWorkingHours(diffHours)
      //   if (diffHours < 9) {
      //     shiftState.endTimeStatus = "error";
      //     shiftState.endTimeErrorMsg = "End Time must be exactly  9 hours after Start Time.";
      //   } else if (diffHours > 9) {
      //     shiftState.endTimeStatus = "error";
      //     shiftState.endTimeErrorMsg = "End Time cannot exceed 9 hours from Start Time.";
      //   } else {
      //     shiftState.endTimeStatus = "success";
      //     shiftState.endTimeErrorMsg = "";
      //     shiftState.endTime = value;
      //   }
    
      //   break;
      // }

      case "endTime": {
    const { startTime } = shiftState;

    if (!startTime) {
      shiftState.endTimeStatus = "error";
      shiftState.endTimeErrorMsg = "Please select Start Time first.";
      break;
    }

    if (!value?.trim()) {
      shiftState.endTimeStatus = "error";
      shiftState.endTimeErrorMsg = "Shift End Time is Mandatory.";
      break;
    }

    const startTimeObj = new Date(`2000-01-01T${startTime}:00`);
    let endTimeObj = new Date(`2000-01-01T${value}:00`);

    if (endTimeObj <= startTimeObj) {
      endTimeObj.setDate(endTimeObj.getDate() + 1); 
    }

    const diffHours = (endTimeObj - startTimeObj) / (1000 * 60 * 60);
    const diff = Math.round(diffHours * 100) / 100; // avoid floating issues
    console.log(diff,"diren");
    
    settotalWorkingHours(diff);

    if (diff !== 9) {
      shiftState.endTimeStatus = "error";
      shiftState.endTimeErrorMsg = "End Time must be exactly 9 hours after Start Time.";
      break;
    }

    // SUCCESS
    shiftState.endTimeStatus = "success";
    shiftState.endTimeErrorMsg = "";
    shiftState.endTime = value;
    break;
}

    
      case "name": {
        const alphaNLengthRegex = /^([a-zA-Z ]{1,25})$/;
    
        if (alphaNLengthRegex.test(value?.trim())) {
          shiftState[name + "Status"] = "success";
        } else {
          shiftState[name + "Status"] = value === "" ? "unchecked" : "error";
        }
    
        break;
      }
    
      default:
        break;
    }
    
  
    shiftState[name] = value;
    setShiftData(shiftState);
  };

  const onAddShift = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onshiftSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onEditShift = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update your Details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        oneditshiftSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ondeleteSubmitShift();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const ondiscardShift = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setShiftData({
      name: originalshiftData.name,
      startTime: originalshiftData.startTime,
      endTime: originalshiftData.endTime,
      nameStatus: originalshiftData.name ? "success" : "unchecked",
      startTimeStatus: originalshiftData.name ? "success" : "unchecked",
      endTimeStatus: originalshiftData.endTime ? "success" : "unchecked"
    });
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onCancelAction = () => {
    navigate("/shift");
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      shifData.nameStatus === "success" &&
      shifData.startTimeStatus === "success" &&
      shifData.endTimeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      shifData.name === originalshiftData.name &&
      shifData.startTime === originalshiftData.startTime &&
      shifData.endTime === originalshiftData.endTime
    ) {
      allowSubmit = false;
    } else if (shifData.name !== originalshiftData.name) {
      if (shifData.nameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (shifData.startTime !== originalshiftData.startTime) {
      if (shifData.startTimeStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (shifData.endTime !== originalshiftData.endTime) {
      if (shifData.endTimeStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "74vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the Shift details for you. This
                    may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card>
          <CardHeader
            title={
              <>
                {togglePage.view === true || togglePage.edit === true ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        {togglePage.view === true
                          ? "View  Shift details"
                          : "Edit Shift details"}
                      </MaterialTypography>
                    </Stack>
                    {AccessData &&
                      Array.isArray(AccessData) &&
                      AccessData.some(
                        (item) =>
                          item.component === "EditShift" && item.can_access
                      ) &&
                      pageState.state !== "submitting" && (
                        <ButtonGroup
                          variant="outlined"
                          aria-label="button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark" // Make sure 'dark' is a valid color in your theme
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          <MaterialButton
                            variant="gradient"
                            color="dark" // Make sure 'dark' is a valid color in your theme
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Shift Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                )}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 6, sm: 6 }}>
                    <MaterialBox>
                      <MaterialBox lineHeight={0} display="inline-block">
                        <MaterialTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                        >
                          Shift Name <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                      </MaterialBox>
                      <MaterialInput
                        name="name"
                        placeholder="eg. Day Shift"
                        value={shifData.name}
                        onChange={handleShiftchange}
                        error={shifData.nameStatus === "error"}
                        success={shifData.nameStatus === "success"}
                        disabled={togglePage.view === true ? true : false}
                      />
                      {shifData.nameStatus === "error" && (
                        <FormControl error>
                          <FormHelperText>
                            Shift Name should be a maximum of 25 characters long
                            and can contain alphabets.
                          </FormHelperText>
                        </FormControl>
                      )}
                    </MaterialBox>
                    <MaterialBox>
  <MaterialBox lineHeight={0} display="inline-block">
    <MaterialTypography component="label" variant="caption" fontWeight="bold">
      Start Time <span style={{ color: "red" }}>*</span>
    </MaterialTypography>
  </MaterialBox>
  <MaterialInput
    name="startTime"
    type="time"
    value={shifData.startTime}
    onChange={handleShiftchange}
    error={shifData.startTimeStatus === "error"}
    success={shifData.startTimeStatus === "success"}
    disabled={togglePage.view === true}
  />
  {shifData.startTimeStatus === "error" && (
    <FormControl error>
      <FormHelperText>Shift Start Time is Mandatory</FormHelperText>
    </FormControl>
  )}
</MaterialBox>

<MaterialBox>
  <MaterialBox lineHeight={0} display="inline-block">
    <MaterialTypography component="label" variant="caption" fontWeight="bold">
      End Time <span style={{ color: "red" }}>*</span>
    </MaterialTypography>
  </MaterialBox>
  <MaterialInput
    name="endTime"
    type="time"
    value={shifData.endTime}
    onChange={handleShiftchange}
    error={shifData.endTimeStatus === "error"}
    success={shifData.endTimeStatus === "success"}
    disabled={!shifData.startTime || togglePage.view === true} // Disabled until Start Time is chosen
  />
  {shifData.endTimeStatus === "error" && (
    <FormControl error>
      <FormHelperText>
        {shifData.endTimeErrorMsg} {/* Dynamic error message */}
      </FormHelperText>
    </FormControl>
  )}
</MaterialBox>

                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your Shift data. This should not take much time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={ondiscardShift}
                  >
                    Discard
                  </MaterialButton>

                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    // disabled={
                    //   !checkFields() 
                    // }
                    onClick={onEditShift}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handlecancel}
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                    sx={{ m: 2, marginLeft: "4px" }}
                    variant="gradient"
                    color="dark"
                    disabled={
                      !checkAllFields() || pageState.state === "submitting"
                    }
                    onClick={onAddShift}
                  >
                    Submit
                  </MaterialButton>
                </>
              ) : null}
            </MaterialBox>
          )}
          {
            <MaterialSnackbar
              color="success"
              icon={<NotificationsIcon />}
              title="Message"
              content="You have been submitted successfully"
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
          {
            <MaterialSnackbar
              color="error"
              position="Top"
              icon={<NotificationsIcon />}
              title="Message"
              content="Please select a start time first."
              open={snackBar.Success}
              close={() =>
                setSnackBar({
                  success: false,
                })
              }
            />
          }
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddShift;
